import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';
import { format } from 'app/shared/utils/string.util';

import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: adfModelTypeMap.gitHub.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.GitHubLabel),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.GitHubLabel)
    ]
})
export class GitHubLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public credential?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
